import debounce from 'lodash/debounce';
import { AnyAction, Middleware } from 'redux';

import { userStorageApi } from 'apis/userStorage';
import { AppState } from 'bootstrap.store';
import {
  CONVERSATION_DRAFTS_TAB_ID,
  conversationDraftsChanged,
} from 'utils/conversationDrafts/conversationDrafts.actions';

/** How long draft broadcasts are collected before refetching. */
const REFETCH_DEBOUNCE_MS = 1_000;

/** Refetches the user storage when another tab writes a draft. */
export const conversationDraftsMiddleware: () => Middleware<
  unknown,
  AppState
> = () => (store) => {
  const refetchUserStorage = debounce(() => {
    store.dispatch(
      userStorageApi.endpoints.readUserStorage.initiate(
        {},
        { forceRefetch: true, subscribe: false },
      ),
    );
  }, REFETCH_DEBOUNCE_MS);

  return (next) => (action: AnyAction) => {
    const result = next(action);

    if (
      conversationDraftsChanged.match(action) &&
      // Our own write is still in flight; refetching it would roll it back.
      action.payload.tabId !== CONVERSATION_DRAFTS_TAB_ID
    ) {
      refetchUserStorage();
    }

    return result;
  };
};
